<div class="echartsLinechartWrapper p-3" [class.dark]="darkThemeActive">
  <div #linechartContainer
       class="echartsLinechartContainer"
       [style.height.px]="passedHeight"
       [class.dimmed]="noDataOnChart"
       [attr.data-linechart-id]="linechartId"></div>
  @if (noDataOnChart) {
    <div class="noDataOverlay">
      <p>{{ 'STATISTICS.NO_CHART_DATA' | translate }}</p>
    </div>
  }
</div>
